module.exports = __webpack_public_path__ + "img/CM-SL-CA-BMW-Playful.0d9ccfe3.jpeg";